import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Loader } from "../components";
import API from "../api";
import { getCountries, getLanguage } from "../utils/utils";

const otherSelectValue = "999999";

const translations = {
  hr: {
    changesSaved: "Promjene su uspješno spremljene!",
    changesError: "Došlo je do greške. Molimo pokušajte ponovo.",
    passwordUpdate: "Izmjena lozinke",
    passwordCurrentLabel: "Trenutna lozinka",
    passwordNewLabel: "Nova lozinka",
    submit: "Spremi",
  },
  en: {
    changesSaved: "The changes were successfully saved!",
    changesError: "There was an error. Please try again.",
    passwordUpdate: "Password Update",
    passwordCurrentLabel: "Current Password",
    passwordNewLabel: "New Password",
    submit: "Save",
  },
  sr: {
    changesSaved: "Promene su uspešno spremljene!",
    changesSachangesErrorved: "Došlo je do greške. Molimo pokušajte ponovo.",
    passwordUpdate: "Izmena lozinke",
    passwordCurrentLabel: "Trenutna lozinka",
    passwordNewLabel: "Nova lozinka",
    submit: "Spremi",
  },
};

export default class Info extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.match.params.id,
      passwordCurrent: "",
      passwordNew: "",
      messages: translations[getLanguage()],
    };
  }

  componentDidMount() {}

  _formOnSubmit = async (event) => {
    event.preventDefault();

    await API.post("", {
      action: "passwordSave",
      current: this.state.passwordCurrent,
      new: this.state.passwordNew,
      id: this.state.id,
    })
      .then((response) => {
        toast(this.state.messages.changesSaved, {
          type: "success",
        });
      })
      .catch((error) => {
        toast(this.state.messages.changesError, {
          type: "error",
        });
      });
  };

  _inputOnChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  render() {
    const {
      categories,
      selectedCategories,
      countries,
      loading,
      info,
      messages,
      rater,
      types,
    } = this.state;

    if (loading) {
      return <Loader />;
    }

    return (
      <div className="page__content">
        <article className="article">
          <h1>{messages.passwordUpdate}</h1>
          <p className="warning">{messages.organizationIntro}</p>
          <form method="post" onSubmit={this._formOnSubmit}>
            <fieldset className="fieldset">
              <label className="label">{messages.passwordCurrentLabel}</label>
              <input
                type="password"
                name="passwordCurrent"
                required={true}
                className="input input--medium"
                onChange={this._inputOnChange}
                autoComplete={true}
              />
            </fieldset>
            <fieldset className="fieldset">
              <label className="label">{messages.passwordNewLabel}</label>
              <input
                type="password"
                name="passwordNew"
                required={true}
                className="input input--medium"
                onChange={this._inputOnChange}
                autoComplete={false}
              />
            </fieldset>
            <fieldset className="fieldset fieldset--button">
              <button type="submit" className="button button--big">
                {messages.submit}
              </button>
            </fieldset>
          </form>
        </article>
        <ToastContainer />
      </div>
    );
  }
}
